import { Injectable, Optional, SkipSelf } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subject } from 'rxjs';
import { ConfirmDialogCredentialsComponent } from 'app/shared/confirm-dialog-credentials/confirm-dialog-credentials.component';
import { RouteNavLockComponent } from './../shared/components/route-nav-lock/route-nav-lock.component';
import { LockedRoute, INavData } from './../shared/interfaces/locked-route';
import { EEntityTypes } from 'app/shared/enums';

@Injectable({ providedIn: 'root' })

export class RouteNavLockService {
  private _routeNavSubject = new Subject<LockedRoute>();
  private locks: LockedRoute[] = [];
  public readonly routeNav$ = this._routeNavSubject.asObservable();
  private isPromptClosed = false;
  afterClosed: Observable<boolean>;

  constructor(private readonly dialog: MatDialog, private readonly translate: TranslateService) { }
  canRouteURL(url: string): Observable<boolean> {
    const lockedRoute = this.locks.find(el => {
      return el.url === url;
    });

    if (lockedRoute && lockedRoute.isLocked) {
      return this.showRouteNavPrompt(lockedRoute.warningMessage, true);
    }

    return of(true);
  }

  lockRoute(route: LockedRoute) {
    const selectedRoute = this.locks.find(r => r.url === route.url);
    if (!selectedRoute) {
      this.locks.push(route);
    }
  }

  disableAllLocks() {
    this.locks = []
  }

  unlockRoute(route: LockedRoute) {
    const routeIndex = this.locks.findIndex(el => {
      return el.url === route.url;
    });
    if (routeIndex > -1) {
      this.locks.splice(routeIndex, 1);
    }
  }

  showRouteNavPrompt(message?: string, isLockedUrl?: boolean): Observable<boolean> {
    if (this.isPromptClosed) {
      return this.afterClosed;
    }

    this.isPromptClosed = true;
    if(message?.includes('irreversible!')){
      message = this.translate.instant('Component.irreversible');
    }

    const dialogRef = this.dialog.open<RouteNavLockComponent, INavData, boolean>(RouteNavLockComponent, { data: { message: message, isLockedUrl: isLockedUrl } });
    this.afterClosed = dialogRef.afterClosed();
    this.afterClosed.subscribe(() => {
      this.isPromptClosed = false;
    });
    return this.afterClosed;
  }

  /**
   * prompt confirmation with credentials demand
   * @param message message
   * @param type type
   */
  showRouteNavPromptWithCredentials(message?: string, type?: EEntityTypes): Observable<any> {
    if (this.isPromptClosed) { return this.afterClosed }
    this.isPromptClosed = true;
    const dialogRef = this.dialog.open<ConfirmDialogCredentialsComponent>(ConfirmDialogCredentialsComponent, {
      data: { message: message, type: type }, height: '80%', width: '60%'
    });

    this.afterClosed = dialogRef.afterClosed();
    this.afterClosed.subscribe(() => {
      this.isPromptClosed = false;
    });

    return this.afterClosed;
  }

}
